<template>
  <div class="ysf">
    客服加载中...
  </div>
</template>

<script>
export default {
  computed: {
  },
  methods: {

  },
  beforeCreate () {
  },
  created () {

  },
  beforeDestroy () {
  },
  components: {

  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.ysf {}
</style>
